import PropTypes from 'prop-types'

const propTypes = PropTypes.shape({
  ssid: PropTypes.string.isRequired,
})

export default propTypes
